export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      paddingTop: 24, 
      paddingBottom: 10, 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
};

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      paddingTop: '8px !important',
      paddingBottom: 6,
      overflow: 'visible',
    },
  },
};

export const MuiDialogActions = {
  styleOverrides: {
    root: {
      paddingLeft: 24,
      paddingRight: 24,
      paddingBottom: 24,
      marginTop: 2,
    },
  },
};

export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: 12,
    },
  },
};
